import { useSuspenseQuery } from "@apollo/client";
import {
    BookedGroupMembersTripsDocument,
    BookedGroupMembersTripsQuery,
    BookedGroupMembersTripsQueryVariables,
} from "generated/graphql";

export const useBookedGroupMembersTrips = (gcDepartureId: string) => {
    const { data } = useSuspenseQuery<
        BookedGroupMembersTripsQuery,
        BookedGroupMembersTripsQueryVariables
    >(BookedGroupMembersTripsDocument, {
        variables: {
            gcDepartureId: gcDepartureId,
            language: process.env.NEXT_PUBLIC_STORYBLOK_LANGUAGE ?? "",
        },
        context: { fetchOptions: { cache: "no-store" } },
    });

    if (data.gcDeparture?.__typename !== "GCDeparture") {
        return {
            gcDeparture: undefined,
        };
    }

    return {
        gcDeparture: data.gcDeparture,
    };
};
